import styles from "./ArticleLeadArt.module.scss";

import { ArticleLayout, ArticleLeadCinemagraphFragment } from "types/api";
import ArticleLeadFigure from "components/article/ArticleLeadFigure";
import Cinemagraph from "components/Cinemagraph";
import { gql } from "utils/urql";
import cx from "classnames";

const ArticleLeadCinemagraph = ({
  layout,
  ...props
}: {
  layout: ArticleLayout;
} & ArticleLeadCinemagraphFragment) => {
  const poster =
    layout === ArticleLayout.Twocol
      ? props.verticalPoster
      : props.horizontalPoster;
  return (
    <>
      {props.__typename === "Cinemagraph" && (
        <ArticleLeadFigure
          layout={layout}
          captionText={props.captionText}
          attributionText={props.attributionText}
        >
          <Cinemagraph
            width={poster?.width || props.vidWidth}
            height={poster?.height || props.vidHeight}
            poster={poster || undefined}
            formats={props.formats}
            className={cx(
              styles.video,
              layout === ArticleLayout.Feature && styles.featureMedia
            )}
          />
        </ArticleLeadFigure>
      )}
    </>
  );
};

ArticleLeadCinemagraph.fragment = gql`
  fragment articleLeadCinemagraph on Cinemagraph {
    vidWidth: width
    vidHeight: height
    attributionText
    captionText
    formats {
      encoding
      url
    }
    horizontalPoster: poster(width: 1920, height: 1080) {
      width
      height
      url
    }
    verticalPoster: poster(width: 1440, height: 1800) {
      width
      height
      url
    }
  }
`;

export default ArticleLeadCinemagraph;
